var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.questions.length > 0
        ? _vm._l(_vm.questions, function (question) {
            return _c(
              "v-list-item",
              {
                key: question.id,
                staticClass: "ps-0 question-item",
                attrs: { to: "/classroom/questions/" + question.id },
              },
              [
                _c("v-list-item-icon", { staticClass: "me-5 ms-5 mt-7" }, [
                  _c("div", { staticClass: "question-box" }, [
                    _c("div", { staticClass: "question-num" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(question.answersCount) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: {
                          "question-active": question.answersCount > 0,
                          "question-deactive": question.answersCount == 0,
                        },
                      },
                      [_vm._v("\n          Ans\n        ")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "v-list-item-content",
                  { staticClass: "pb-10" },
                  [
                    _c("v-list-item-title", {
                      staticClass: "question-title-small",
                      domProps: {
                        textContent: _vm._s(_vm.relaticeObject(question)),
                      },
                    }),
                    _vm._v(" "),
                    _c("v-list-item-title", {
                      staticClass: "question-title",
                      domProps: {
                        textContent: _vm._s(
                          _vm.stringTruncate(question.title, 25)
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("v-list-item-subtitle", [
                      question.createdAt
                        ? _c("span", { staticClass: "me-2" }, [
                            _vm._v(_vm._s(question.createdAt.substring(0, 10))),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "me-2" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("thumb_up"),
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(question.voteValues) +
                              "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      question.user && question.user.image
                        ? _c("img", {
                            staticStyle: { width: "15px" },
                            attrs: { src: question.user.image.url },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      question.user && question.user.name
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.stringTruncate(question.user.name, 10))
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && _vm.questions.length == 0
        ? _c("p", { staticClass: "mt-2", staticStyle: { color: "#666666" } }, [
            _vm._v("質問はまだありません。"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }